/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface X509CertificateAndDIDResult { 
    /**
     * The descentralized identification of the subject. It is a type of identifier that allows the verification of decentralized identities. Format: \'did : ala : network (specifies the technology used on that network) : net-id (defines the specific blockchain network instance) : address (of the proxy smart contract generated in de create identity process)\'. \'did:ala:quor:redT:01edb987f7841117e558626577e51c68467b97f1\', for example.
     */
    did?: string;
    /**
     * The X509Certificate created for the subject.
     */
    x509Certificate?: X509CertificateAndDIDResult.X509CertificateEnum;
}
export namespace X509CertificateAndDIDResult {
    export type X509CertificateEnum = '[B@153cd6bb';
    export const X509CertificateEnum = {
        B153cd6bb: '[B@153cd6bb' as X509CertificateEnum
    };
}


